/* 0511ER v8 — produkt.js: Größenwahl, Einzeln/Set, Galerie-Zähler, Maßtabelle.
   Der Warenkorb (AJAX + Drawer) läuft weiter über stufe3.js: es liest das Feld name="id". */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var daten;
  try { daten = JSON.parse(root.querySelector('[data-pdp-json]').textContent); } catch (e) { return; }
  var T = daten.t || {};

  /* ── Galerie: Zähler und Punkte beim Wischen ── */
  var track = root.querySelector('[data-galerie-track]');
  var pos = root.querySelector('[data-galerie-pos]');
  var punkte = root.querySelectorAll('.pdp-galerie-punkte span');
  if (track && pos) {
    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        pos.textContent = i + 1;
        punkte.forEach(function (p, j) { p.classList.toggle('ist-aktiv', j === i); });
        tick = false;
      });
    }, { passive: true });
  }

  /* ── Maßtabelle öffnen ── */
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-zur-tabelle]')) return;
    var fit = document.getElementById('pdp-fit');
    if (!fit) return;
    fit.open = true;
    fit.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var form = root.querySelector('[data-pdp-form]');
  if (!form) return;
  var idInput = form.querySelector('[name="id"]');
  var btn = form.querySelector('[data-add]');
  if (!idInput || !btn) return;
  var btnText = btn.querySelector('[data-add-text]');
  var btnPreis = btn.querySelector('[data-add-preis]');
  var preisEl = root.querySelector('[data-preis]');
  var einzelPreisEl = root.querySelector('[data-einzelpreis]');
  var gruppen = {
    einzeln: form.querySelector('[data-gruppe="einzeln"]'),
    set: form.querySelector('[data-gruppe="set"]')
  };
  var modus = 'einzeln';

  function werte(gruppe) {
    var w = [];
    if (!gruppe) return w;
    gruppe.querySelectorAll('[data-opt]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-opt'), 10);
      if (el.type === 'radio') { if (el.checked) w[i] = el.value; }
      else w[i] = el.value;
    });
    return w;
  }
  function finde(liste, w) {
    return liste.find(function (v) { return v.o.every(function (x, i) { return x === w[i]; }); });
  }
  /* Werte, die mit der übrigen Auswahl ausverkauft sind, durchstreichen */
  function markiere(gruppe, liste, w) {
    if (!gruppe) return;
    gruppe.querySelectorAll('input[type="radio"][data-opt]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-opt'), 10);
      var test = w.slice(); test[i] = el.value;
      var v = finde(liste, test);
      el.parentElement.classList.toggle('ist-aus', !v || !v.a);
    });
    gruppe.querySelectorAll('[data-wert]').forEach(function (s) {
      var i = parseInt(s.getAttribute('data-wert'), 10);
      if (w[i] != null) s.textContent = w[i];
    });
  }
  /* Zeile der gewählten Größe in der Maßtabelle markieren */
  function markiereTabelle(groesse) {
    root.querySelectorAll('[data-masse] tr[data-groesse]').forEach(function (tr) {
      tr.classList.toggle('ist-gewaehlt', tr.getAttribute('data-groesse') === groesse);
    });
  }

  function update() {
    var ist = modus === 'set' && daten.set;
    var liste = ist ? daten.set.varianten : daten.varianten;
    var gruppe = ist ? gruppen.set : gruppen.einzeln;
    var w = werte(gruppe);
    var v = finde(liste, w);
    markiere(gruppe, liste, w);

    if (v) idInput.value = v.id;
    btn.disabled = !v || !v.a;
    if (btnText) btnText.textContent = !v ? T.none : (!v.a ? T.sold : (ist ? T.addSet : T.add));
    if (btnPreis) btnPreis.textContent = v ? v.p : '';
    if (preisEl && v) preisEl.textContent = v.p;

    if (!ist) {
      var eigene = daten.varianten.length && finde(daten.varianten, w);
      if (einzelPreisEl && eigene) einzelPreisEl.textContent = eigene.p;
      markiereTabelle(w[w.length - 1]);
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  /* Wechsel Einzeln ↔ Set. Beim Set wird die gewählte Größe für dieses Teil übernommen. */
  form.querySelectorAll('[data-kaufart]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      modus = r.value;
      var ist = modus === 'set';
      if (gruppen.einzeln) gruppen.einzeln.hidden = ist;
      if (gruppen.set) gruppen.set.hidden = !ist;
      if (ist && daten.set && gruppen.set) {
        var eigen = werte(gruppen.einzeln);
        var groesse = eigen[eigen.length - 1];
        var ziel = gruppen.set.querySelector('input[data-opt="' + daten.set.idx + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(groesse) : groesse) + '"]');
        if (ziel) ziel.checked = true;
      }
      update();
    });
  });

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[data-opt]')) update();
  });

  update();
})();
